import { render, staticRenderFns } from "./create-users.vue?vue&type=template&id=2b049a89&"
import script from "./create-users.vue?vue&type=script&lang=js&"
export * from "./create-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports